/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
/**
 * Request body parameters for creating a new product
 */
export type CatalogProductCreateBodyParams = {
    /**
     * Product name - required
     */
    name: string;
    /**
     * Product description
     */
    description?: string | null;
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    currency?: CatalogProductCreateBodyParams.currency | null;
    /**
     * Optional reference to the analysis configuration
     */
    analysisConfigId?: number | null;
    /**
     * Optional custom fields for the product
     */
    customFields?: Dictionary_unknown_;
    /**
     * External source identifier for the product
     */
    sourceId?: string | null;
    /**
     * External URL referencing the product
     */
    sourceUrl?: string | null;
    /**
     * Optional canonical price in the provided currency
     */
    price?: string | null;
};
export namespace CatalogProductCreateBodyParams {
    /**
     * Currency code for the price (defaults to CLP if omitted)
     */
    export enum currency {
        CLP = 'CLP',
        UF = 'UF',
    }
}

